import { useEffect, useRef, useState } from "react";
import { Calendar } from "lucide-react";

function ymdToDmy(ymd) {
  if (!ymd || !/^\d{4}-\d{2}-\d{2}$/.test(ymd)) return "";
  const [year, month, day] = ymd.split("-");
  return `${day}/${month}/${year}`;
}

function parseDmy(value) {
  const match = String(value || "").trim().match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (!match) return null;
  const day = Number(match[1]);
  const month = Number(match[2]);
  const year = Number(match[3]);
  const date = new Date(year, month - 1, day);
  if (
    date.getFullYear() !== year ||
    date.getMonth() !== month - 1 ||
    date.getDate() !== day
  ) {
    return null;
  }
  return `${String(year).padStart(4, "0")}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
}

function maskDmy(value) {
  const digits = String(value || "").replace(/\D/g, "").slice(0, 8);
  if (digits.length <= 2) return digits;
  if (digits.length <= 4) return `${digits.slice(0, 2)}/${digits.slice(2)}`;
  return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`;
}

export default function DateInput({ id, value, min, max, onChange }) {
  const [text, setText] = useState(ymdToDmy(value));
  const pickerRef = useRef(null);

  useEffect(() => {
    setText(ymdToDmy(value));
  }, [value]);

  const emitIfValid = (raw) => {
    const ymd = parseDmy(raw);
    if (!ymd) return;
    if (min && ymd < min) return;
    if (max && ymd > max) return;
    onChange(ymd);
  };

  const openPicker = () => {
    const picker = pickerRef.current;
    if (!picker) return;
    if (typeof picker.showPicker === "function") {
      try {
        picker.showPicker();
        return;
      } catch (_) {
        // Fall back to click when the browser blocks showPicker.
      }
    }
    picker.click();
  };

  return (
    <div className="admin-date-wrap">
      <input
        id={id}
        type="text"
        inputMode="numeric"
        autoComplete="off"
        placeholder="dd/mm/aaaa"
        className="admin-control-input admin-date-text"
        value={text}
        onChange={(event) => {
          const next = maskDmy(event.target.value);
          setText(next);
          emitIfValid(next);
        }}
        onBlur={() => {
          setText(ymdToDmy(value));
        }}
      />
      <input
        ref={pickerRef}
        type="date"
        className="admin-date-native"
        value={value || ""}
        min={min}
        max={max}
        tabIndex={-1}
        aria-hidden="true"
        onChange={(event) => onChange(event.target.value)}
      />
      <button
        type="button"
        className="admin-date-calendar"
        onClick={openPicker}
        aria-label="Abrir calendário"
      >
        <Calendar size={18} />
      </button>
    </div>
  );
}
